import { createEndpoint } from 'new/api/utils';
import { api } from 'new/api/axios';
import { GoLiveMultiRequest } from './types.ts';

export const goLiveSingleEndpoint = createEndpoint({
  url: '/office/:id/tier-membership/go-live',
  endpoint: ({ url }) => api.post(url),
});

export const goLiveMultiEndpoint = createEndpoint<unknown, GoLiveMultiRequest>({
  url: '/office/:id/tier-membership/go-live-multi',
  endpoint: ({ url, params }) => api.post(url, params),
});
